import { z } from 'zod';

import { leadSchema } from 'entities/Lead';

import { meetingSchemaBase } from './MeetingSchemaBase';

export const meetingSchema = meetingSchemaBase
  .extend({
    lead: z.lazy(() => leadSchema).nullable(),
  })

  .transform((raw) => {
    return {
      id: raw.id,
      status: raw.status,
      lead: raw.lead,
      slot: raw.slot,
      project: raw.project,
      client: raw.client,
      isOffline: raw.is_offline,
      manager: raw.manager,
      responsible: raw.responsible,
    };
  });

export type MeetingEntityApi = z.input<typeof meetingSchema>;

export type MeetingEntity = z.infer<typeof meetingSchema>;
